import React from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import PersonIcon from "@mui/icons-material/Person";
import LoadingButton from "@mui/lab/LoadingButton";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { Field, Form, Formik } from "formik";
import { TextField } from "formik-material-ui";
import { Grid } from "@mui/material";
import axios from "axios";
import ENV from "../../../environment";
import { useParams } from "react-router-dom";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "50%",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
};

export const baseregex = /^([\s]*)(?!.*<.*>)(?!.* or .*=).*([\s]*)$/i;
export const phoneregex = /^([+]?\d{1,3})\s?(\d{2,3}\s?){2,3}\d{0,3}$/;

function TransitionsModal({ handleOpenMainModal, isPartner, getData }) {
    const { hotelid } = useParams();
    const [loading, setLoading] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const validate = Yup.object({
        contact_name: Yup.string()
            .required("Field is required")
            .matches(baseregex, { message: "Invalid value" }),
    
        email: Yup.string()
            .email("Invalid value")
            .optional(),
    
        phone_number: Yup.string()
            .matches(phoneregex, { message: "Invalid value" })
            .optional(),
    
        phone_type: Yup.string()
            .required("Please select a phone type"),
    }).test("phone-or-email", "Must contain at least one of the following: phone number, email", (values) => {
        return !!values.phone_number || !!values.email;
    });

    const emptyData = { contact_name: "", phone_number: "", email: "", phone_type: "" };

    const onSubmit = async (values) => {
        console.log(22)
        const data = {
            contact_name: values.contact_name,
            phone_number: values.phone_number,
            phone_type: values.phone_type,
        };
        if (values.email) data.email = values.email;

        setLoading(true);
        await axios
            .post(`${ENV.URL}/api/hdp/tts/adm/hotel/contact/${hotelid}`, data, {
                headers: {
                    Authorization: sessionStorage.getItem("token"),
                    "client-id": ENV.CLIENTID,
                    "client-secret": ENV.SECRET,
                },
            })
            .then((res) => {
                setLoading(false);
                toast.success("Saved successfully");
                handleClose();
                getData();
            })
            .catch((err) => {
                setLoading(false);
                toast.error(err?.response?.data?.errors[0]?.message || "An error occurred");
            });
    };

    return (
        <div className="modal_res">
            <Button
                onClick={() => {
                    if (isPartner) {
                        handleOpenMainModal();
                        return "";
                    }
                    handleOpen();
                }}
                variant="contained"
                startIcon={<PersonIcon />}
            >
                {"Add contact"}
            </Button>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={open}
                onClose={handleClose}
                closeAfterTransition
                slots={{ backdrop: Backdrop }}
                slotProps={{ backdrop: { timeout: 500 } }}
            >
                <Fade in={open}>
                    <Box sx={style} className="modal_res">
                        <Typography id="transition-modal-title" variant="h6" component="h2" className="marginBottom">
                            {"Enter contact info"}
                        </Typography>
                        <Formik
                            initialValues={emptyData}
                            validationSchema={validate}
                            onSubmit={(values) => {
                                console.log("Form Submitted:", values); // Debugging
                                onSubmit(values);
                            }}
                        >
                            {({ values, errors }) => (
                                <Form autoComplete="off" className="mt-4">
                                    <Grid container spacing={4}>
                                        <Grid item xs={12}>
                                            <Field
                                                fullWidth
                                                name="contact_name"
                                                size="small"
                                                component={TextField}
                                                label={"Contact name"}
                                                type="text"
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Field
                                                fullWidth
                                                name="phone_number"
                                                size="small"
                                                component={TextField}
                                                label={"Phone number"}
                                                type="text"
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Typography variant="subtitle1">Phone Type</Typography>
                                            <Field name="phone_type">
                                                {({ field }) => (
                                                    <RadioGroup {...field} row>
                                                        <FormControlLabel value="land_line" control={<Radio />} label="Landline" />
                                                        <FormControlLabel value="mobile" control={<Radio />} label="Mobile" />
                                                    </RadioGroup>
                                                )}
                                            </Field>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Field
                                                fullWidth
                                                name="email"
                                                size="small"
                                                component={TextField}
                                                label={"Email"}
                                                type="text"
                                            />
                                        </Grid>

                                    </Grid>
                                    <div className="right_left">
                                        <Button onClick={handleClose} variant="contained" sx={{ mt: 3, mb: 2 }} color="error">
                                            {"Close"}
                                        </Button>
                                        <>
                                            {loading ? (
                                                <LoadingButton loading variant="contained" sx={{ mt: 3, mb: 2 }} color="success">
                                                    {"Submit"}
                                                </LoadingButton>
                                            ) : (
                                                <Button type="submit" variant="contained" sx={{ mt: 3, mb: 2 }} color="success">
                                                    {"Submit"}
                                                </Button>
                                            )}
                                        </>
                                    </div>
                                    {loading && <div className="overlay" />}
                                </Form>
                            )}
                        </Formik>
                    </Box>
                </Fade>
            </Modal>
        </div>
    );
}

export default React.memo(TransitionsModal);
